import { websiteText } from '@/mixins/websiteTexts';
export const getMissingImage = (cssClass: string) => {
    const missingImageText = websiteText('general.imagemissing');
    const missingImageHtml = `<picture class='dummy-image ${cssClass}' >
    <div class='dummy-container'>
        <div class='dummy-inner'>
            <img src='/ui/assets/img-missing.svg' data-sizes='auto' data-src='' title='${missingImageText}' alt='${missingImageText}' class='block-image lazyloaded'>
            <span>${missingImageText}</span>
            </div>
        </div>
    </picture>`;
    
    return missingImageHtml;
};